'use client';

import { useState, createContext } from 'react';

import {
  type ConfigContextType,
  type Config,
  createConfigContext,
} from '@openclassrooms/utils/config';

export const ConfigContext = createContext<ConfigContextType | null>(null);

export function ConfigProvider({
  children,
  config,
}: Readonly<{
  children: React.ReactNode;
  config: Config;
}>) {
  const [configContext] = useState(() => createConfigContext(config));

  return <ConfigContext.Provider value={configContext}>{children}</ConfigContext.Provider>;
}
